import { render, staticRenderFns } from "./AddTasks.vue?vue&type=template&id=e6967c10&scoped=true&"
import script from "./AddTasks.vue?vue&type=script&lang=js&"
export * from "./AddTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6967c10",
  null
  
)

export default component.exports